var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"outer"},[_c('div',{staticClass:"inner",style:({width: _vm.value + '%', background: _vm.color})})])
}
var staticRenderFns = []

export { render, staticRenderFns }